import React from 'react';
const Bgdrop = props => {
    return <div onClick={props.close} className="backdrop" />
};
export default Bgdrop;